import { api, AxiosResponse } from 'api/axios';
import { UserInfo } from 'model/account';
import { useQuery } from 'react-query';

export async function login(data: {
  email: string;
  password: string;
}): Promise<AxiosResponse<UserInfo>> {
  const user = await api.post('/account/login?from=web', data);
  return user;
}

export async function exchangeToken(
  jwtToken: string,
): Promise<AxiosResponse<UserInfo>> {
  const user = await api.post(
    '/account/exchange-token',
    {
      expiresIn: 60 * 60 * 1.5,
    },
    {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
      },
    },
  );
  return user;
}

export async function getMe(): Promise<AxiosResponse<UserInfo>> {
  const user = await api.get('/account/me/');
  return user.data;
}

export const useUser = (token?: string) => {
  const { data, ...rest } = useQuery<unknown, unknown, UserInfo>(
    ['user', token],
    () => getMe(),
    {
      enabled: !!token,
    },
  );
  return {
    user: data,
    ...rest,
  };
};

export async function register(data: {
  email: string;
  password: string;
  verificationCode: string;
}): Promise<AxiosResponse<UserInfo>> {
  const user = await api.post('/account/register', data);
  return user;
}

export async function resetPassword(data: {
  email: string;
  password: string;
  verificationCode: string;
}): Promise<AxiosResponse<UserInfo>> {
  const user = await api.post('/account/reset-password', {
    email: data.email,
    password: data.password,
    verificationCode: data.verificationCode,
    app: 'HomeLink',
  });
  return user;
}

export async function sendCode(data: {
  email: string;
  type:
    | 'register'
    | 'reset_password'
    | 'change_email'
    | 'delete_account'
    | 'general';
}): Promise<AxiosResponse<void>> {
  const res = await api.post('/account/send-code', data);
  return res;
}

export async function validateCode({
  verificationCode,
}: {
  verificationCode: string;
}) {
  await api.post('/account/validate-code', {
    verificationCode,
  });
}
